import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sign",
  "use": "icon-sign-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"icon-sign\">\r\n<path d=\"M11.3,3.1L9.9,1.3C9.7,1.1,9.5,1,9.3,1H2.9C2.6,1,2.4,1.1,2.3,1.3L0.8,3.1C0.7,3.3,0.6,3.6,0.6,3.9v3C1.1,6,2.1,5.3,3.3,5.3\r\n\tc1.8,0,3.2,1.4,3.2,3.2c0,1-0.5,2-1.3,2.5h5.5c0.5,0,0.9-0.4,0.9-0.9V3.9C11.6,3.6,11.5,3.3,11.3,3.1z M1.3,3.1l0.5-0.6h2.4l0.3-0.5\r\n\tH2.2l0.4-0.4c0.1-0.1,0.2-0.1,0.3-0.1h6.4c0.1,0,0.2,0,0.3,0.1l0.4,0.4H7.6l0.2,0.5h2.6l0.5,0.6H1.3z\" />\r\n<path d=\"M3.3,11.1C2,11.1,0.8,10,0.8,8.6S2,6.1,3.3,6.1s2.5,1.1,2.5,2.5S4.7,11.1,3.3,11.1z M3.3,6.7c-1,0-1.9,0.9-1.9,1.9\r\n\ts0.9,1.9,1.9,1.9s1.9-0.9,1.9-1.9S4.4,6.7,3.3,6.7z\" />\r\n<path d=\"M3.2,9.5c-0.1,0-0.2,0-0.3-0.1L2.3,8.7c-0.1-0.1-0.1-0.2,0-0.3c0.1-0.1,0.2-0.1,0.3,0l0.5,0.5l1.1-1.1\r\n\tc0.1-0.1,0.2-0.1,0.3,0c0.1,0.1,0.1,0.2,0,0.3L3.5,9.3C3.4,9.4,3.3,9.5,3.2,9.5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sign.svg
// module id = HE8u
// module chunks = 217